import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { AdministracionService } from '../../../../services/backend/administracion/administracion.service';
@Component({standalone:true,imports:[RouterLink,RouterLinkActive,RouterOutlet,FormsModule],templateUrl:'./administration.component.html',styleUrl:'./administration.component.css'})
export class AdministrationComponent implements OnInit {
  readonly api=inject(AdministracionService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  readonly authorities = signal(false);
  readonly sections=[{path:'usuarios',label:'Usuarios'},{path:'roles',label:'Roles'},{path:'permisos',label:'Gestionar permisos'},{path:'reasignaciones',label:'Reasignar usuarios'},{path:'listas-parametros',label:'Listas y parámetros'},{path:'autoridades-ambientales',label:'Autoridades ambientales'}];
  ngOnInit():void{
    const update = () => {
      const standalone = !['/usuarios', '/roles', '/permisos', '/reasignaciones', '/administracion'].some(path => this.router.url.split('?')[0].endsWith(path));
      this.authorities.set(standalone);
      if (!standalone && !this.api.data() && !this.api.loading()) this.api.load();
    };
    update();
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(e => {if(e instanceof NavigationEnd) update();});
  }
}
